module.exports = __webpack_public_path__ + "media/old_images/logo-undervattenskartan-2bbb33ea.png";